import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../utils/PrivateRoute/PrivateRoute';
import Loader from '../../common/Loader/Loader';
import { LEADS_ROUTES } from './core/constants/routes';

const LeadsListPage = lazy(() => import('./workflow/list/LeadsListPage'));
const LeadDetailPage = lazy(() => import('./workflow/detail/LeadDetailPage'));
const LeadAssignmentPage = lazy(() => import('./workflow/assignment/LeadAssignmentPage'));

const PAGE_BY_PATH = {
  [LEADS_ROUTES.LIST]: LeadsListPage,
  [LEADS_ROUTES.DETAIL]: LeadDetailPage,
  [LEADS_ROUTES.ASSIGNMENT]: LeadAssignmentPage,
};

function LeadsShell({ element: Page }) {
  return (
    <Suspense fallback={<Loader />}>
      <PrivateRoute element={Page} />
    </Suspense>
  );
}

/** Pre-built Route elements for App.js. Every Leads page is private. */
export const leadsRouteElements = (
  <>
    {Object.values(LEADS_ROUTES).map((path) => (
      <Route key={path} path={path} element={<LeadsShell element={PAGE_BY_PATH[path]} />} />
    ))}
  </>
);
